import Api from '../index';
import {IEtkinliklerKaydet, IGunsonu, IGunsonuKaydet, IMesailerKaydet} from "../../constants/types/logbook";

const LogbookApi = {
    login(credentials: any) {
        return Api.postPromise('/logbook/auth/token/', credentials).then((resp: any) => {
            return resp;
        });
    },

    getSabitler() {
        return Api.getPromise('/logbook/sabitler/');
    },

    getGunsonu(tarih: string) {
        return Api.getPromise<IGunsonu>('/logbook/gunsonu/gunsonukayit/', {tarih});
    },

    setGunsonu(model: IGunsonuKaydet) {
        return Api.postPromise('/logbook/gunsonu/gunsonukayit/', model);
    },

    getHesapKayit(hesapId?: number, page = 1, pageSize = 25) {
        return Api.getPromise('/logbook/yonetim/hesapkayit/', {hesapId, page, page_size: pageSize});
    },

    postHesapKayit(model: any) {
        return Api.postPromise('/logbook/yonetim/hesapkayit/', model);
    },

    putHesapKayit(model: any) {
        return Api.putPromise('/logbook/yonetim/hesapkayit/', model);
    },

    deleteHesapKayit(params: any) {
        return Api.deletePromise('/logbook/yonetim/hesapkayit/', params);
    },

    getKisiDetaylari(kisiId?: number, page = 1, pageSize = 25) {
        return Api.getPromise('/logbook/yonetim/kisi/', {kisiId, page, page_size: pageSize});
    },

    postKisiDetaylari(model: any) {
        return Api.postPromise('/logbook/yonetim/kisi/', model);
    },

    postKisiAktif(kisiId: number) {
        return Api.postPromise('/logbook/yonetim/kisiAktif/', {kisiId});
    },

    postKisiSifre(model: any) {
        return Api.postPromise('/logbook/yonetim/kisiSifre/', model);
    },

    postKisiAvatar(kisiId: number, formData: FormData) {
        return Api.postPromise(`/logbook/yonetim/kisi/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            params: {kisiId}
        });
    },

    putKisiDetaylari(model: any) {
        return Api.putPromise('/logbook/yonetim/kisi/', model);
    },

    getGiderler(params: any) {
        return Api.getPromise('/logbook/yonetim/giderler/', params);
    },

    postGider(model: any) {
        return Api.postPromise('/logbook/yonetim/giderler/', model);
    },

    getHesapRaporlari() {
        return Api.getPromise('/logbook/yonetim/raporlar/');
    },

    getTakvimKayitlari(params: { baslangicTarih: string, bitisTarih: string }) {
        return Api.getPromise('/logbook/takvim/takvimkayit/', params);
    },

    postMesailer(body: IMesailerKaydet) {
        return Api.postPromise('/logbook/takvim/mesailer/', body);
    },

    postEtkinlikler(body: IEtkinliklerKaydet) {
        return Api.postPromise('/logbook/takvim/etkinlikler/', body);
    },
};

export default LogbookApi;
